// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IValidatePhoneResponseSchema {
  /** Время до следующей отправки кода подтверждения **/
  confirmTimeout?: number;
  /** Статус подтверждения телефона **/
  status: EStatus;
}
export enum EStatus {
  /** Введен неправильный код **/
  'Error' = 'error',
  /** В процессе проверки **/
  'InProgress' = 'inProgress',
  /** Проверка успешно завершена **/
  'Ok' = 'ok',
  /** Проверка пропущена **/
  'Skipped' = 'skipped',
}
